import { useSparkRewards } from './logic/useSparkRewards'
import { AccountConnectingView } from './views/AccountConnectingView'
import { GuestView } from './views/GuestView'
import { RewardsView } from './views/RewardsView'
import { useConnectModal } from '@/domain/hooks/wallet'
import { useConnectedAddress } from '@/domain/wallet/useConnectedAddress'

export function SparkRewardsContainer() {
  const rewards = useSparkRewards()
  const { account, isConnecting } = useConnectedAddress({ throwOnNotConnected: false })
  const { openConnectModal = () => {} } = useConnectModal()

  if (isConnecting && account === undefined) {
    return <AccountConnectingView />
  }

  if (account === undefined) {
    return <GuestView ongoingCampaignsResult={rewards.ongoingCampaignsResult} openConnectModal={openConnectModal} />
  }

  return <RewardsView {...rewards} />
}
